import { render, staticRenderFns } from "./Avzyz.vue?vue&type=template&id=c6a8ae62&scoped=true&"
import script from "./Avzyz.vue?vue&type=script&lang=js&"
export * from "./Avzyz.vue?vue&type=script&lang=js&"
import style0 from "./Avzyz.vue?vue&type=style&index=0&id=c6a8ae62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a8ae62",
  null
  
)

export default component.exports